module.exports = __webpack_public_path__ + "img/carousel-1.2257219f.png";